// extracted by mini-css-extract-plugin
export default {"container":"KT7zUE7Ujm09a7l28jRF","chart-area":"EgM2JePZm5PkZkafSFqJ","legend":"RxG_4aBkWehnvo4UnBfo","legend-item":"MBl9mlGNjijKdwJiWnSw","legend-color":"EjDq5x6ifPehnHxQmNkQ"};